import React from 'react';
import Input from '../../../components/ui/Input';

const PersonalInfoSection = ({ formData, errors, onChange }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center">
        Informações Pessoais
        <span className="text-error ml-1">*</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Nome completo"
          type="text"
          placeholder="Digite o nome completo"
          value={formData?.fullName}
          onChange={(e) => onChange('fullName', e?.target?.value)}
          error={errors?.fullName}
          required
        />
        
        <Input
          label="Data de nascimento"
          type="date"
          value={formData?.dateOfBirth}
          onChange={(e) => onChange('dateOfBirth', e?.target?.value)}
          error={errors?.dateOfBirth}
          required
        />
        
        <Input
          label="CPF"
          type="text"
          placeholder="000.000.000-00"
          value={formData?.cpf}
          onChange={(e) => onChange('cpf', e?.target?.value)}
          error={errors?.cpf}
          description="Documento CPF (11 dígitos)"
          required
        />
        
        <Input
          label="Título de eleitor"
          type="text"
          placeholder="Digite o título de eleitor"
          value={formData?.voterId}
          onChange={(e) => onChange('voterId', e?.target?.value)}
          error={errors?.voterId}
          description="Número de identificação do eleitor"
          required
        />
        
        <Input
          label="Gênero"
          type="text"
          placeholder="Masculino/Feminino/Outro"
          value={formData?.gender}
          onChange={(e) => onChange('gender', e?.target?.value)}
          error={errors?.gender}
        />
        
        <Input
          label="Ocupação"
          type="text"
          placeholder="Digite a ocupação"
          value={formData?.occupation}
          onChange={(e) => onChange('occupation', e?.target?.value)}
          error={errors?.occupation}
        />
      </div>
    </div>
  );
};

export default PersonalInfoSection;